import {useRouteMatch, Switch, Route, Redirect} from 'react-router-dom';

// import PaymentGateway from './PaymentGateway';
import Billing from './BillingDetails/BillingDetails';
import PricingPlans from './PricingPlans';
import TariffUpdate from './TariffUpdate';
import History from './History';
import CompanyDetails from 'pages/CompanyDetails';
import TemplateList from '../Template/TemplateList';
import TemplateForm from '../Template/TemplateForm';
import TemplateDetails from '../Template/TemplateDetails';

import styles from './Settings.module.scss';
import useAuth from 'hooks/useAuth';
import {get} from 'lodash';
import Integrations from './Integrations';

function Settings() {
  const {currentUser} = useAuth();
  const {path} = useRouteMatch();

  return (
    <div className={styles.root}>
      <Switch>
        <Route path={`${path}/billing`} exact component={Billing} />
        <Route path={`${path}/plans`} exact component={PricingPlans} />
        <Route path={`${path}/billing/update`} component={TariffUpdate} />
        <Route path={`${path}/billing/history`} component={History} />
        <Route path={`${path}/integrations`} component={Integrations} />
        <Route path={`${path}/company`} component={CompanyDetails} />
        <Route path={`${path}/templates`} exact component={TemplateList} />
        <Route path={`${path}/templates/create`} component={TemplateForm} />
        <Route path={`${path}/templates/:slug`} component={TemplateDetails} />
        <Redirect
          to={
            get(currentUser, 'company.plan')
              ? `${path}/billing`
              : `${path}/plans`
          }
        />
      </Switch>
    </div>
  );
}

export default Settings;
